import { create } from 'zustand';
import type { RoomClaimDTO } from '@campus/core';

/**
 * Salles revendiquées par un duo sur la carte courante (ZoneRoom `claims:state`)
 * et salles revendicables (GET /world/zones/:slug/bubble-zones, `claimable`).
 * Affichage seulement : le serveur refuse l'entrée et le tableau.
 */
interface RoomClaimsState {
  /** zoneId → revendication en cours. */
  claims: ReadonlyMap<string, RoomClaimDTO>;
  /** zoneId des salles revendicables de la carte. */
  claimable: ReadonlySet<string>;
  setClaims: (claims: RoomClaimDTO[]) => void;
  setClaimable: (zoneIds: Iterable<string>) => void;
}

export const useRoomClaimsStore = create<RoomClaimsState>((set) => ({
  claims: new Map(),
  claimable: new Set(),
  setClaims: (claims) => set({ claims: new Map(claims.map((c) => [c.zoneId, c])) }),
  setClaimable: (zoneIds) => set({ claimable: new Set(zoneIds) }),
}));
